import './app.css';
import { mount } from 'svelte';
import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';
import App from './App.svelte';
import { addCatalog, language, setLanguage } from './lib/i18n/index.ts';

// Every catalog ships with the page (spec 013); the browser's languages pick
// one, and a development build takes ?lang= for the pseudo-language.
const arbs = import.meta.glob(['../../i18n/common/*.arb', '../../i18n/web/*.arb'], { query: '?raw', import: 'default', eager: true });
for (const text of Object.values(arbs)) addCatalog(JSON.parse(text as string));
const asked = import.meta.env.DEV ? new URLSearchParams(location.search).get('lang') : null;
setLanguage(asked ? [asked] : navigator.languages, import.meta.env.DEV);
document.documentElement.lang = language();

// maplibre-gl cannot find its worker inside a bundle, so Vite emits the
// worker as its own file and the map loads it from there.
setWorkerUrl(workerUrl);

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
